// Dirección lista para Google Maps (25-oct-2026). Las direcciones cargadas traen cosas que confunden a
// Google: "Pierres 81 Pasillo, Domínico" lo mandaba a un pet shop y "Itati 1522, Lomas de zamora" a otro
// partido. Se saca lo que va después de la altura y el piso/depto, se completan las localidades cortas y
// se agrega la provincia. Si hay coordenadas, mejor usar esas (linkRuta, linkGps).
const LOCALIDADES = {
    caba: 'Ciudad Autónoma de Buenos Aires', 'capital federal': 'Ciudad Autónoma de Buenos Aires',
    dominico: 'Villa Domínico, Avellaneda', 'domínico': 'Villa Domínico, Avellaneda', varela: 'Florencio Varela',
    lomas: 'Lomas de Zamora', 'lomas de zamora': 'Lomas de Zamora', echeverria: 'Esteban Echeverría', 'echeverría': 'Esteban Echeverría',
    lanus: 'Lanús', 'lanús': 'Lanús', banfield: 'Banfield', temperley: 'Temperley', quilmes: 'Quilmes', avellaneda: 'Avellaneda',
};
const PISO = /^(piso|p\.?\s*\d|pb|ph|depto|dpto|dto|departamento|of|oficina|local|torre|uf|\d+\s*[°º]?\s*[a-z]?$)/i;

export function direccionParaMaps(d) {
    const partes = String(d || '').split(',').map(x => x.trim()).filter(Boolean);
    if (!partes.length) return '';
    const m = partes[0].match(/^(\D*?\S\s+\d{1,5})\b\s*(.*)$/);
    // "Laprida 490 lomas, Lanús": la localidad pegada a la calle manda (como en el backend)
    const pegada = m && LOCALIDADES[m[2].trim().toLowerCase()];
    if (m) partes[0] = m[1];
    const resto = pegada ? [pegada] : partes.slice(1).filter(x => !PISO.test(x)).map(x => LOCALIDADES[x.toLowerCase()] || x);
    const salida = [partes[0], ...resto].join(', ');
    return /buenos aires|argentina/i.test(salida) ? `${salida}, Argentina` : `${salida}, Buenos Aires, Argentina`;
}
